import type { LimitOrderResponse } from 'apiConnector/secondary-market/limit-order/models';
import type { OrderMap, OrderState } from 'state/secondaryMarket/shared/order/order.model';

export type LimitOrderState = OrderState<LimitOrderResponse>;

export type LimitOrderMap = OrderMap<LimitOrderResponse>;

export const initialLimitOrderMap = (): LimitOrderMap => ({});
